import React from "react";
import "./Remove_Member.css";
import SideDrawer from "../../../../Components/sideDrower/SideDrawer";
import { removemember_dp } from "../../../../assets";
import { HiOutlineArrowSmallLeft } from "react-icons/hi2";

const Remove_Member = ({ RemovememberModal, setRemovememberModal }) => {
  return (
    <SideDrawer
    className={"button_set_btm"}
      show={RemovememberModal}
      handleClose={() => setRemovememberModal(false)}
    >
      <div className="remove_member_parent">
        <div className="remove_member_wraper">
          <h3 className="remove_member_title">Members</h3>
        </div>

        <div className="remove_member_child">
          <div className="remove_member_details">
            <img src={removemember_dp} />
            <p className="remove_person">
              Are you sure you want to remove this member?
            </p>
          </div>

          <div className="remove_btn_wrap">
            <button className="cancel">No, Cancel</button>
            <button className="remove">Yes, Remove</button>
          </div>
        </div>

        <div className="back_button">
          <button type="button" className="back_move">
            <HiOutlineArrowSmallLeft className="left_arrow" /> Back
          </button>
        </div>
      </div>
    </SideDrawer>
  );
};

export default Remove_Member;
